import React from "react";

const ErrorFallback = () => <div>Error</div>;
export default ErrorFallback;
